import MuiCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { Field, type FieldRenderProps } from "react-final-form";

interface CheckboxProps {
  name: string;
  label?: string;
  helperText?: string;
  disabled?: boolean;
  [key: string]: any;
}

export function Checkbox(props: CheckboxProps) {
  return (
    <Field
      {...props}
      type="checkbox"
      render={(fieldProps: FieldRenderProps<any, HTMLElement>) => {
        const {
          input,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          meta,
          helperText,
          label,
          disabled,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          name,
          ...rest
        } = { ...fieldProps, ...props };

        return (
          <div>
            <FormControlLabel
              control={
                <MuiCheckbox
                  {...input}
                  disabled={disabled}
                  color="primary"
                  {...rest}
                />
              }
              label={label}
              disabled={disabled}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
          </div>
        );
      }}
    />
  );
}
